import Cookies from 'js-cookie'

const TokenKey = 'Business-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getLanguage() {
  let language = localStorage.getItem('language')
  if(!language){
    language = 'CN'
    localStorage.setItem('language','CN')
  }
  return language
}